export default __webpack_public_path__ + "static/media/acceleration_16318834.a955922d.svg";